/**
 * Claves de `provide`/`inject`. La app raíz (`main.ts`) provee estos valores y los componentes los reciben con
 * `@Inject(InjectionKey.X)` de `vue-property-decorator`, sin importar nada de `tenants/<cliente>/`.
 */
export enum InjectionKey {
    /** `TenantConfig` activo. */
    Tenant = 'tenant',
    /** `AccessControl` (el `AccessCoordinator`: delega en la estrategia de la ruta activa). */
    Access = 'access',
    /** `CustomerContext`: aseguradora de la ruta activa (logo y nombre del header; colores por aseguradora). */
    Customer = 'customer',
    /** Adaptador que implementa `ClaimsPort` (análisis del siniestro; todos los tenants). */
    ClaimsApi = 'claimsApi',
    /** Adaptador que implementa `ItemPort` (`/ranch/...`; todos los tenants). */
    ItemApi = 'itemApi',
    /** `ClaimManagementPort` (lista/detalle/polígono del siniestro) o `null` si el backend no lo soporta. */
    ClaimManagementApi = 'claimManagementApi',
    /** `ItemClaimsPort` (item con sus siniestros, muestreo) o `null` si el backend no lo soporta. */
    ItemClaimsApi = 'itemClaimsApi'
}
